// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "mvc/chunk-" + {"165":"filter","464":"search","582":"modal","741":"search-full"}[chunkId] + ".css";
};